module.exports = __webpack_public_path__ + "static/media/slide4.9769146c.webp";